<template src="./form.html"></template>

<script>
import countryOptions from './countryOptions'

export default {
  name: 'exportPresetForm',
  data() {
    return {
      contractList: [],
      countryInputMap: {},
      expandedCountryMap: {},
      countryOptions,
      form: {
        name: '',
        code: '',
        notes: '',
        manual_dsps: [],
        export_contracts: [],
      },
      manualDspOptions: [
        { value: 'bugs', label: 'Bugs' },
        { value: 'flo', label: 'FLO' },
        { value: 'genie', label: 'Genie' },
        { value: 'melon', label: 'Melon' },
        { value: 'vibe', label: 'Vibe' },
      ],
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
    isDark() {
      const t = this.$store.state.theme
      return t === 'dark' || t === 'semi-dark'
    },
    sortedExportContracts() {
      return [...this.form.export_contracts].sort((a, b) => {
        return this.getContractName(a.id).localeCompare(this.getContractName(b.id))
      })
    },
  },
  mounted() {
    this.loadContracts()
    if (this.isEdit) {
      this.loadPreset()
    }
  },
  methods: {
    loadContracts() {
      this.$store.dispatch('GET_EXPORT_CONTRACTS', { limit: 100, page: 0 })
        .then((result) => {
          this.contractList = result.items || result || []
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(() => this.$router.push('/login'))
          }
        })
    },
    loadPreset() {
      this.loadingShow()
      this.$store.dispatch('GET_EXPORT_CONTRACT_PRESET', { id: this.$route.params.id })
        .then((result) => {
          this.loadingHide()
          const data = result.data || result
          this.form = {
            name: data.name || '',
            code: data.code || '',
            notes: data.notes || '',
            manual_dsps: Array.isArray(data.manual_dsps) ? [...data.manual_dsps] : [],
            export_contracts: (data.export_contract_preset_export_contract || []).map(item => ({
              id: item.export_contract_id,
              territory_exception_v2: item.territory_exception_v2 ? [...item.territory_exception_v2] : [],
            })),
          }
          this.form.export_contracts.forEach(entry => {
            this.$set(this.countryInputMap, entry.id, null)
          })
        })
        .catch((error) => {
          this.loadingHide()
          if (error.response && error.response.status === 401) {
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(() => this.$router.push('/login'))
          }
        })
    },
    isDspSelected(value) {
      return this.form.manual_dsps.includes(value)
    },
    toggleDsp(value) {
      if (this.form.manual_dsps.includes(value)) {
        this.form = { ...this.form, manual_dsps: this.form.manual_dsps.filter(v => v !== value) }
      } else {
        this.form = { ...this.form, manual_dsps: [...this.form.manual_dsps, value] }
      }
    },
    isContractSelected(id) {
      return this.form.export_contracts.some(e => e.id === id)
    },
    toggleContract(contract) {
      const idx = this.form.export_contracts.findIndex(e => e.id === contract.id)
      if (idx >= 0) {
        const updated = this.form.export_contracts.filter(e => e.id !== contract.id)
        this.form = { ...this.form, export_contracts: updated }
        const { [contract.id]: _, ...rest } = this.countryInputMap
        this.countryInputMap = rest
      } else {
        const updated = [...this.form.export_contracts, { id: contract.id, territory_exception_v2: [] }]
        this.form = { ...this.form, export_contracts: updated }
        this.$set(this.countryInputMap, contract.id, null)
      }
    },
    removeContractById(id) {
      const updated = this.form.export_contracts.filter(e => e.id !== id)
      this.form = { ...this.form, export_contracts: updated }
      const { [id]: _c, ...restC } = this.countryInputMap
      this.countryInputMap = restC
      const { [id]: _e, ...restE } = this.expandedCountryMap
      this.expandedCountryMap = restE
    },
    toggleCountryInput(id) {
      this.$set(this.expandedCountryMap, id, !this.expandedCountryMap[id])
    },
    addTerritoryExceptionFromSelect(contractId, code) {
      if (!code) return
      const raw = code.trim().toUpperCase()
      const entryIndex = this.form.export_contracts.findIndex(e => e.id === contractId)
      if (entryIndex < 0) return
      const entry = this.form.export_contracts[entryIndex]
      if (entry.territory_exception_v2.includes(raw)) {
        this.$set(this.countryInputMap, contractId, null)
        return
      }
      const updatedEntry = { ...entry, territory_exception_v2: [...entry.territory_exception_v2, raw] }
      const updatedContracts = this.form.export_contracts.map((e, i) => i === entryIndex ? updatedEntry : e)
      this.form = { ...this.form, export_contracts: updatedContracts }
      this.$nextTick(() => {
        this.$set(this.countryInputMap, contractId, null)
      })
    },
    removeTerritoryException(contractId, codeIndex) {
      const entryIndex = this.form.export_contracts.findIndex(e => e.id === contractId)
      if (entryIndex < 0) return
      const entry = this.form.export_contracts[entryIndex]
      const updatedEntry = {
        ...entry,
        territory_exception_v2: entry.territory_exception_v2.filter((_, i) => i !== codeIndex),
      }
      const updatedContracts = this.form.export_contracts.map((e, i) => i === entryIndex ? updatedEntry : e)
      this.form = { ...this.form, export_contracts: updatedContracts }
    },
    getContractName(id) {
      const found = this.contractList.find(c => c.id === id)
      return found ? found.name : `Contract #${id}`
    },
    getCountryLabel(code) {
      const found = this.countryOptions.find(c => c.value === code)
      return found ? found.label : code
    },
    countryFilter(option, label, search) {
      const s = search.toLowerCase()
      return option.value.toLowerCase().includes(s) || label.toLowerCase().includes(s)
    },
    validate() {
      if (!this.form.name || !this.form.name.trim()) {
        this.alert({ msg: '이름을 입력해주세요.' })
        return false
      }
      if (!this.form.code || !this.form.code.trim()) {
        this.alert({ msg: '코드를 입력해주세요.' })
        return false
      }
      return true
    },
    save() {
      if (!this.validate()) return
      const params = {
        name: this.form.name.trim(),
        code: this.form.code.trim(),
        notes: this.form.notes ? this.form.notes.trim() : null,
        manual_dsps: [...this.form.manual_dsps],
        export_contracts: this.form.export_contracts.map(e => ({
          id: e.id,
          territory_exception_v2: e.territory_exception_v2,
        })),
      }
      this.loadingShow()
      const action = this.isEdit ? 'PUT_EXPORT_CONTRACT_PRESET' : 'POST_EXPORT_CONTRACT_PRESET'
      const payload = this.isEdit
        ? { id: this.$route.params.id, params }
        : { params }
      this.$store.dispatch(action, payload)
        .then(() => {
          this.loadingHide()
          this.noti(this.isEdit ? '수정되었습니다.' : '등록되었습니다.')
          this.$router.push({ path: '/export-preset' })
        })
        .catch((error) => {
          this.loadingHide()
          const msg = error.response && error.response.data
            ? error.response.data.message
            : '저장 중 오류가 발생했습니다.'
          this.alert({ msg })
        })
    },
  },
}
</script>

<style scoped>
.contract-row {
  position: relative;
}

.contract-row__main {
  display: flex;
  align-items: center;
  padding: 9px 4px;
  gap: 8px;
  min-height: 42px;
}

.contract-row__identity {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.contract-dot {
  width: 7px;
  height: 7px;
  background: #28C76F;
  border-radius: 50%;
  flex-shrink: 0;
}

.contract-name {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contract-id {
  font-size: 11px;
  flex-shrink: 0;
}

.contract-row__exclusions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  flex-shrink: 0;
}

.btn-add-exclusion {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid;
  background: transparent;
  cursor: pointer;
  transition: opacity 0.15s;
  white-space: nowrap;
  line-height: 1.6;
}
.btn-add-exclusion:hover {
  opacity: 0.7;
}

.btn-remove-contract {
  font-size: 16px;
  line-height: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0 4px;
  flex-shrink: 0;
  transition: opacity 0.15s;
  opacity: 0.4;
}
.btn-remove-contract:hover {
  opacity: 0.9;
}

/* expand/collapse via grid-template-rows */
.exclusion-expander {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}
.exclusion-expander.is-open {
  grid-template-rows: 1fr;
}
.exclusion-expander__inner {
  overflow: hidden;
  padding-bottom: 0;
  transition: padding-bottom 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}
.exclusion-expander.is-open .exclusion-expander__inner {
  padding-bottom: 10px;
}
</style>
